import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  grey800,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_size_3xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

const LIST_WIDTH = '320px'

export default css`
  .Activity-list {
    width: ${LIST_WIDTH};
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-right: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};

    .Activity-list-title {
      padding: ${spacing(5)};
      font-family: ${font_family_weight_medium};
      font-size: ${font_size_3xl};
      line-height: 30px;
      color: ${grey800};
    }
  }

  .Activity-details {
    padding: ${spacing(10)} ${spacing(20)};
    flex: 1 0 0;
    align-self: stretch;
  }
`
